import { call, receive } from '../../communication/api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createCoreMethod = <R, T extends (...args: any) => Promise<R>>(
  key: string,
  method: T
): ((...args: Parameters<T>) => ReturnType<T>) => {
  const caller = async (...args: Parameters<T>) => {
    return await call<ReturnType<T>>(key, ...args);
  };

  if (!window) {
    receive(key, async (...args: Parameters<T>) => {
      return await method(...args);
    });
  }

  return caller as (...args: Parameters<T>) => ReturnType<T>;
};
